import './App.css';
import React, { lazy, Suspense, useState , useRef} from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import 'normalize.css';
import Audio from './pages/protected/Home/Audio';
import { motion } from "framer-motion";

// Pages
const Home = lazy(() => import('./pages/protected/Home/LandingIntro'));
const MainLanding = lazy(() => import('./pages/protected/Home/MainLanding'));


// Persistent Audio Player


function App() {
  const [started, setStarted] = useState(false);
  const [fly, setFly] = useState(false);
  const audioRef = useRef(null);
  const handleBegin = async  () => {
    setFly(true);

  await new Promise((resolve) => setTimeout(resolve, 1000)); // wait 800ms

  setStarted(true);
  };

  return (
    <Router>
      <div className="w-full overflow-x-hidden">
        
        {/* Intro overlay */}
        {!started  && (
          <div className="intro-overlay ">
            <div
              className="relative rounded-2xl overflow-y-scroll  overflow-hidden flex-shrink-0 w-[300px] tablet-portrait:w-[480px] tablet-landscape:w-[480px] md:w-[480px] lg:w-[480px] h-[380px]" 
            >
            <motion.img
            src="./airplane.svg"
            alt="airplane"
            className="w-56 md:w-60 absolute left-4 right-4 border-transparent rounded-none justify-center mx-auto text-center bottom-12"
            initial={{ x: "-60%", y: 0, rotate: 0 }}   // 👈 start off-screen left
            animate={
              fly
                ? { x: "120vw", y: -400, rotate: 10 }     
                : { x: 0, y: 0, rotate: 0 }              // ✨ idle in center
            }
            transition={{ duration: 2, ease: "easeInOut" }}
          />

              <img
                src='./frame2.png'
                alt="#TheDualloveExperience2026"
                className="w-full h-full object-cover "
              />

            {
              !fly&&(
                <div className="absolute inset-0 flex flex-col items-center justify-center p-4 pt-28 text-center animate-fadeInUp">
                <button className="begin-btn font-medium text-[#374b70] px-4 py-4 text-xs md:text-base tablet-portrait-specific:text-sm"  onClick={handleBegin}>
                      Tap to begin our story 💜
                    </button>
                <p className="text-[#374b70]/60 text-[0.55rem] tablet-portrait-specific:text-xs md:text-[0.7rem] tracking-wide mt-3">#TheDualLoveExperience2026</p>
              </div>
              )
            }
              
            </div>
          </div>
        )}

        {/* Persistent Audio */}
        {started && <Audio started={started} audioRef={audioRef} />}
      

        {/* Page content */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/" element={started&&<Home play={started}  audioRef={audioRef} />} />
            {/* <Route path="/main" element={<MainLanding />} /> */}
            {/* Add more routes here */}
          </Routes>
        </Suspense>

        {/* Footer */}
        {/* <Footer className='z-50'/> */}
      </div>
    </Router>
  );
}

export default App;
